// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1IyeJ","jobs":"style_jobs__1Eczt","job":"style_job__3UUQA","title":"style_title__zCHi4","moreInfo":"style_moreInfo__1rI-1"};